<template>
    <div class="loading-wrap" @mousemove="onMouseMove($event)">
        <div class="loading-spinner" ref="loading" :style="{transform:`translate(${pos.left}px, ${pos.top}px)`}">
            <svg viewBox="0 0 149.2 149.2">
                <path fill="#FF5032" d="M120.6,15.8L74.6,74.6L46.7,5.4C70.6-4.2,98.8-1.2,120.6,15.8"/>
                <path fill="#0079C4" d="M148.5,85L74.6,74.6l45.9-58.8C142.3,32.8,152.1,59.5,148.5,85"/>
                <path fill="#FFE500" d="M133.4,120.5c-8.4,10.7-19.1,18.5-30.8,23.3l-28-69.2L148.5,85C146.8,97.5,141.8,109.8,133.4,120.5"/>
                <path fill="#A3BF80" d="M102.6,143.8c-23.9,9.6-52.1,6.6-73.9-10.4l45.9-58.8L102.6,143.8z"/>
                <path fill="#858788" d="M74.6,74.6l-45.9,58.8c-21.8-17-31.5-43.7-28-69.2L74.6,74.6z"/>
                <path fill="#8B2C31" d="M74.6,74.6L0.7,64.2c1.7-12.6,6.7-24.8,15.1-35.5C24.2,18,34.9,10.2,46.7,5.4L74.6,74.6z"/>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loading',

    props: {
        pos: {
            default: {},
            type: Object,
        }
    },

    // methods: {
    //     onMouseMove(e) {
    //         // console.log(e);
    //         // this.left = e.pageX;
    //         // this.top = e.pageY;
    //         // this.$refs.loading.style.top = e.screenY + 'px';
    //         // this.$refs.loading.style.left = e.screenX + 'px';
    //         // if (this.$refs.loading) this.$refs.loading.style.transform = `translate(${e.screenX}px, ${e.screenY}px)`;
    //     }
    // },
    // mounted() {
    //     console.log('1')
    // },

}

</script>

<style lang="scss">
    $size: 12rem;

    .loading-wrap {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: rgba(#000000, 0);
        z-index: 9999999;
        overflow: hidden;
        cursor: none;

        &.static .loading-spinner {
            left: 50% !important;
            top: 50% !important;
        }
    }

    .loading-spinner {
        width: $size;
        height: $size;
        pointer-events: none;
        position: absolute;
        margin: -#{$size/2} 0 0 -#{$size/2};
        z-index: 9999999;

        
        svg {
            width: $size;
            height: $size;
            animation: loading-ring 1.2s linear infinite;
        }
    }



    //   animation: loading-ring 1.2s linear infinite;
    // }
    @keyframes loading-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @media only screen and (max-width: 767px) {
        $size: 30rem;
        .loading-spinner {
            width: $size;
            height: $size;
            margin: -#{$size/2} 0 0 -#{$size/2};

            
            svg {
                width: $size;
                height: $size;
            }
        }
    }

</style>
